const VISIT_SETTLEMENT_PAYMENT_ENABLED_PREFERENCE_KEY = 'visitSettlementPaymentEnabledPreference';

export const visitSettlementPaymentStorage = {
   setEnabledPreference: (enabled: boolean): void => {
      window.localStorage.setItem(VISIT_SETTLEMENT_PAYMENT_ENABLED_PREFERENCE_KEY, String(enabled));
   },
   getEnabledPreference: (): boolean => {
      const enabled = window.localStorage.getItem(VISIT_SETTLEMENT_PAYMENT_ENABLED_PREFERENCE_KEY);

      if (enabled === null) {
         return true;
      }

      return enabled === 'true';
   },
};
